import React, { FormEvent, FormEventHandler, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import API from "../Api";
import { toast } from "react-toastify";
import Input from "../schema/Input";
import { getCredentialSubject } from "../schema/Utils";

export default function Issuer() {
  const [params] = useSearchParams();

  const [display, setDisplay] = useState<any>({});
  const [order, setOrder] = useState<string[]>([]);
  const [data, setData] = useState<any>({});
  const [reason, setReason] = useState("");
  const [message, setMessage] = useState("");
  const [scope, setScopes] = useState<any>();
  const [loading, setLoading] = useState(true);

  const setPartialData = (name: string, val: any): void => {
    setData({ ...data, [name]: val });
  };

  const onSubmit = (hasAccepted: boolean): ((e?: FormEvent<HTMLFormElement>) => void) => {
    return (e?: FormEvent<HTMLFormElement>) => {
      if(e) {
        e.preventDefault();
      }
      const brand = params.get("brand");
      const issuance_id = params.get("id");
      let url = "/api/v1";
      if (brand) {
        url += "/brand/" + brand;
      } else {
        url += "/brand/root";
      }
      url += "/issue?id=" + issuance_id;

      let text = "approved";
      if (!hasAccepted) {
        text = "denied";
      }

      API(url, {
        method: "POST",
        body: JSON.stringify({
          subject: data,
          accept: hasAccepted,
          reason: reason,
        }),
      })
        .then((response) => {
          setMessage("You " + text + " credential issuance request.");
          toast.success("Credential issuance request resolved", { theme: "colored" });
        })
        .catch((e) => {
          setMessage("Error: " + e);
          toast.error("Error " + e, { theme: "colored" });
          console.error(e);
        });
      }
  };

  useEffect(() => {
    const brand = params.get("brand");
    const issuance_id = params.get("id");
    let url = "/api/v1";
    if (brand) {
      url += "/brand/" + brand;
    } else {
      url += "/brand/root";
    }
    url += "/issue?id=" + issuance_id;
    API(url)
      .then((response) => {
        setDisplay(response.metadata.credentialSubject);
        if (response.metadata.order && response.metadata.order.length > 0) {
          setOrder(response.metadata.order);
        } else {
          setOrder(Object.keys(response.metadata.credentialSubject));
        }
        //Scope
        if (response) {
          console.log(response);
          setScopes(response);
          setData(response.subject);
        }
        setLoading(false);
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <div className="mobile-pro">
        <div className="login">
          <img src="img/issue-icon-default.svg" />
          <h2>Issuance request</h2>
        </div>
      </div>
      <div className="col-content">
        <div className="notifications-container">
          <div className="details-pro-section">
            {message === "" ? (
              <>
                <div className="messages  no-mobile-pro">
                  <h2 style={{marginBottom: "30px"}}>Credential issuance request</h2>
                </div>
                <form onSubmit={onSubmit(true)} className="form">
                  {!loading && (
                    <>
                      <Input
                        content={getCredentialSubject(scope.schema.content)}
                        required
                        value={data}
                        onChange={(val: any) => {
                          setData(val);
                        }}
                      ></Input>

                      <div>
                        <label>
                          If you want to deny, please write here, why you are
                          denying the credential request:
                        </label>
                        <input
                          type="text"
                          className="issuer-form"
                          maxLength={300}
                          value={reason}
                          onChange={(e) => {
                            setReason(e.target.value);
                          }}
                        ></input>
                      </div>

                      <div className="button-options">
                        <button
                          className="form-submit-btn btn btn-options btn-primary"
                          type="submit"
                        >
                          Approve
                        </button>
                        <button
                          className="form-submit-btn btn btn-options btn-secondary button-2"
                          type="button"
                          onClick={(e) => {
                            onSubmit(false)();
                          }}
                        >
                          Deny
                        </button>
                      </div>
                    </>
                  )}
                </form>
              </>
            ) : (
              <h2>{message}</h2>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
